import { OrgId, SalePointId } from 'app/common/types/id'
import { getSalePoints } from 'app/dataProviders/salePoint'
import { SalePoint } from 'app/common/types/sale-points'

let currentAbortController: AbortController | undefined
export const getFilterSalePoints = async (orgId: OrgId) => {
  currentAbortController?.abort()
  currentAbortController = new AbortController()
  const items = await getSalePoints({ orgId }, currentAbortController?.signal)
  if (items) {
    return items.reduce(
      (acc, { id, title, deleted }: SalePoint) => {
        if (!deleted) {
          acc.push({
            id,
            title,
          })
        }
        return acc
      },
      [] as { id: SalePointId; title: string }[],
    )
  }
  return []
}
